import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { NodInsights } from "./nod-Insights";
import { Listing } from "./pages/Listing/index";

export const NodInsightsRoute: IRoute = {
  title: "Insights",
  path: "/nod/insights",
  icon: HomeIcon,
  component: NodInsights,
  guard: true,
  subRoutes: [{ icon: InfoIcon, component: Listing, path: "/insights", title: "Insights" }],
};
